import { Component } from '@angular/core';
import { EmptyStateComponent } from '../../core/panels/empty-state.component';

@Component({
  selector: 'app-not-found-page',

  imports: [EmptyStateComponent],
  template: `
    <div class="tw-flex tw-items-center tw-justify-center tw-h-full">
      <app-empty-state
        icon="fa-light fa-triangle-exclamation"
        label="404 Not found"
        message="The resource does not exist"
      />
    </div>
  `,
  styles: [``],
})
export class NotFoundPageComponent {}
